import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Domain } from "../models/Domain";

interface IUseCreateDomainReturn {
  fetch: UseFetchResult<Domain, FormData>;
}

export const useCreateDomain = (): IUseCreateDomainReturn => {
  const fetch = useFetch<Domain, FormData>("/api/domains", {
    method: "post",
    withToast: true,
    skipInitialFetch: true,
  });

  return {
    fetch: {
      ...fetch,
    },
  };
};
